import { render, staticRenderFns } from "./ratio-edit.vue?vue&type=template&id=01bcf0fc&scoped=true&"
import script from "./ratio-edit.vue?vue&type=script&lang=js&"
export * from "./ratio-edit.vue?vue&type=script&lang=js&"
import style0 from "./ratio-edit.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ratio-edit.vue?vue&type=style&index=1&id=01bcf0fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bcf0fc",
  null
  
)

export default component.exports